// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3569":"dce966c2","4536":"3c039f77","7811":"dce966c2"}[chunkId] + ".chunk.css";
};